var chunkToChildrenMap = {
	"236": [
		3956
	],
	"279": [
		3956
	],
	"424": [
		3956
	],
	"974": [
		3956,
		965
	],
	"1675": [
		3956
	],
	"3254": [
		8762,
		1854,
		7338,
		5707,
		3466,
		8857,
		3869,
		5190,
		279
	],
	"3315": [
		3956,
		5755
	],
	"3494": [
		3956,
		8772
	],
	"3521": [
		8451
	],
	"3741": [
		3956
	],
	"4869": [
		3956,
		8772,
		6822
	],
	"7069": [
		9686
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));